module.exports = __webpack_public_path__ + "static/media/house.e1267541.svg";